module.exports = __webpack_public_path__ + "img/einstein.043cad4b.svg";